import React from 'react'



const ContactInformation = () => {
  return (<> 
 
  <ul className="contact-list">
                    <li className="list-item">
                        <i className="fa fa-map-marker fa-2x">
                            <span className="contact-text place">Behira Governorate, Egypt</span>
                        </i>
                    </li>
                  
                  <li className="list-item">
                      <i className="fa fa-phone fa-2x">
                          <span className="contact-text phone">
                              <a href="tel:+201-111-260138" title="Give me a call">(20)111-126-0138</a>
                            </span>
                        </i>
                </li>
                  
                  <li className="list-item">
                      <i className="fa fa-envelope fa-2x">
                          <span className="contact-text gmail">
                              <a href="mailto:mohamed.elzonqoly@gmail.com" title="Send me an email">
                                  mohamed.elzonqoly@gmail.com
                              </a>
                          </span>
                      </i>
                  </li>
                  
                </ul>
                 <hr />
                 <br/>

                <div className="copyright">&copy; Mohamed Saied</div>
  
  </>
)
}

export default ContactInformation